import { PaymentSource, PaymentStatus } from 'api/gql-utils/bonusAssignment/types';
import { bonusSource, bonusStatus } from '../types';

export const PAYMENT_STATUS_TO_BONUS_STATUS: Record<string, string> = {
  [PaymentStatus.PENDING]: bonusStatus.BONUS_STATUS_PENDING,
  [PaymentStatus.PAID]: bonusStatus.BONUS_STATUS_PAID,
  [PaymentStatus.CLAWBACK_APPLICABLE]: bonusStatus.BONUS_STATUS_CLAWBACK_APPLIED,
};

export const PAYMENT_SOURCE_TO_BONUS_SOURCE: Record<string, string> = {
  [PaymentSource.WITHIN_PAYROLL]: bonusSource.BONUS_SOURCE_WITHIN_XPAYROLL,
  [PaymentSource.ALREADY_PAID]: bonusSource.BONUS_SOURCE_OUTSIDE_XPAYROLL,
};
